<template>
  <div class="doclist">
    <!-- 评分蒙版 -->
    <div class="rate-mask" v-if="isRateMaskShow">
      <div class="rate-area">
          <div class="rate-text">
            <h3>请给出您的评价</h3>
            <div @click="handleRateCancel" class="rate-cancel-icon" src="">
            </div>
          </div>
          <div class="rate-block">
            <el-rate class="rate-choose" v-model="rateValue"></el-rate>
          </div>
          <div class="rate-function">
            <div @click="handleRateCancel" class="rate-cancel">取消</div>
            <div @click="handleRate">提交</div>
          </div>
      </div>
    </div>
    <!-- 上传文件蒙版 -->
    <el-dialog
      title="上传资料"
      :visible.sync="isUploadShow"
      width="530px"
      class="doc-upload-area"
      :close-on-click-modal='false'
      :before-close="cancelUpload">
        <div>
          <h4 style="text-indent: 20px;">标题：</h4>
          <input type="text" v-model="uploadFileTitle" placeholder="请输入文档标题（限200字）..."/>
          <h4 style="text-indent: 20px;">下载所需积分：</h4>
          <input type="text" v-model="uploadFileScore" placeholder="请输入下载所需积分（0-5）"/>
          <h4 style="margin-top: 20px; text-indent: 20px;">描述：</h4>
          <textarea v-model="uploadFileDescribe" placeholder="请输入文档描述（限1000字）..."></textarea>
        </div>
        <div class="doc-upload-typechoose">
          <div v-if="uploadFileTypeChooseOne" class="doc-upload-kindonechoose"
            style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
            <h4 style="padding-left: 20px">分类</h4>
            <ul>
              <li @click="handleUploadFileTypeOneChoose(index, item)" :class="activeUploadFileTypeOneIndex === index?'uploadFileTypeOneActive':''" v-for="(item, index) in uploadFileTypeChooseOne" :key="index">
                {{item.fileTypeName}}
              </li>
            </ul>
          </div>
          <div v-if="uploadFileTypeChooseTwo" class="doc-upload-kindtwochoose"
          style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
            <ul>
              <li @click="handleUploadFileTypeTwoChoose(index, item)" :class="activeUploadFileTypeTwoIndex === index?'uploadFileTypeTwoActive':''" v-for="(item, index) in uploadFileTypeChooseTwo" :key="index">
                {{item.fileTypeName}}
              </li>
            </ul>
          </div>
          <div v-if="uploadFileTypeChooseThree" class="doc-upload-kindtwochoose"
          style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
            <ul>
              <li @click="handleUploadFileTypeThreeChoose(index, item)" :class="activeUploadFileTypeThreeIndex === index?'uploadFileTypeThreeActive':''" v-for="(item, index) in uploadFileTypeChooseThree" :key="index">
                {{item.fileTypeName}}
              </li>
            </ul>
          </div>
        </div>
        <div style="padding-left: 20px" slot="tip" class="el-upload__tip">只能上传doc/docx/pdf/ppt/pptx/xls/xlsx文件，且不超过100Mb</div>
        <el-upload
          class="upload-demo"
          :before-remove="removeFile"
          :on-success="successFile"
          :on-error="errorFile"
          :before-upload="beforeUpload"
          :file-list="fileList"
          ref="upLoadFile"
          :limit="1"
          :on-exceed="handleExceed"
          :headers="headerMsg"
          accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.pdf"
          :action="uploadURL">
          <div slot="trigger" class="uploadPickUp">
            <i class="el-icon-upload2"></i> 选取文件
          </div>
          <p>文件大小不能大于100MB</p>
          <p>支持拓展名：.pdf .doc .docx .xls .xlsx .ppt .pptx</p>
          <!-- <p>文件名只支持汉字、英文字母以及数字</p> -->
          <el-button style="
            width: 265.5px;
            margin-top:50px;
            margin-left: 235px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1D65A8;
            color: white;
            border: 0;
            display: none;
          " size="small" type="success" @click="submitUpload">确定</el-button>
        </el-upload>
        <div style="
          display:flex;
          margin-top: 40px;
          width: 530px;
          margin-left: -20px;
          margin-bottom: -30px;
          "
        >
          <div
            style=" flex: 1"
            class="upload-cancel" @click="cancelUpload">
            取消上传
          </div>
          <div style="
            width: 265.5px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1D65A8;
            color: white;
            text-align: center;
            line-height: 52px;
            flex: 1;
            user-select: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: normal;
          " @click="submitUpload">
            确定上传
          </div>
        </div>
    </el-dialog>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/onlineTraining' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/trainbook' }">工业文库</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/trainbookDocList', query: {...routerQuery} }">{{fileMessage ? fileMessage.parentName : '详情'}}</el-breadcrumb-item>
      <el-breadcrumb-item v-show="false">详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 详情页大板 -->
    <div class="doclist-lastarea">
      <!-- 左侧分类及分页列表 -->
      <div class="doclist-lastarea-l">
        <div class="docdetail-message" v-if="fileMessage">
          <h2>
            {{fileMessage.fileTitle}}
          </h2>
          <div class="docdetail-about">
            <div>
              <img :src="fileMessage.userAvatarURL" :alt="fileMessage.userNickname">
              {{fileMessage.userNickname}} 上传 | {{fileMessage.fileCommentCount}} 个评论 | {{fileMessage.fileViewCount}} 次浏览 | {{fileMessage.fileDownloadCunt}} 次下载 | {{fileMessage.fileCollectCount}} 次收藏 {{fileMessage.createTime}}
            </div>
            <div class="docdetail-likeicon" @click.stop="changeLikeState">
              <img :src="fileMessage.collectionDataId?likeUrl:notLikeUrl" alt="收藏">
              <div>{{fileMessage.collectionDataId?'已收藏':'收藏'}}</div>
            </div>
          </div>
          <div class="docdetail-showmark">
            文档评分：
            <el-rate
              v-model="value"
              disabled
              show-score
              disabled-void-icon-class="el-icon-star-off"
              text-color="#1D65A8"
              disabled-void-color="#1D65A8"
              score-template="{value}">
            </el-rate>
          </div>
        </div>
        <ul v-if="svgList">
          <li v-for="(item, index) in svgList" :key="index">
            <img style="width: 830px;border: 1px solid #dddddd;" :src="item" :alt="fileMessage.fileTitle">
          </li>
        </ul>
        <p
          style="
            text-align: left;
            font-size: 12px;
            line-height: 24px;
            color: #333333;
          "
        >免责声明：本文所载内容来源于互联网、微信公众号等公开渠道，我们对文中观点持中立态度，仅供读者参考、交流。转载的稿件版权归原作者和机构所有，如有侵权，请联系我们删除。</p>
        <div class="docdetail-function">
          <div @click="download">立即下载</div>
          <div @click="isRateMaskShow = true">评价</div>
        </div>
        <div class="docdetail-trivia">
          <h3>相关资料</h3>
          <div
            v-if="relatedDocuments === null || relatedDocuments.length === 0"
            style="margin: 40px 0; font-size: 20px; text-indent: 2em;"
          >
            暂无相关资料
          </div>
          <ul v-if="relatedDocuments">
            <li v-for="item in relatedDocuments" :key="item.totalId" @click="jumpDocDetail2(item)">
              <img v-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'xls'" :src="BASE_URL + 'img/excel.png'" :alt="item.fileName"/>
              <img v-else-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'xlsx'" :src="BASE_URL + 'img/excel.png'" :alt="item.fileName"/>
              <img v-else-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'doc'" :src="BASE_URL + 'img/word.png'" :alt="item.fileName"/>
              <img v-else-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'docx'" :src="BASE_URL + 'img/word.png'" :alt="item.fileName"/>
              <img v-else-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'pdf'" :src="BASE_URL + 'img/ppf.png'" :alt="item.fileName"/>
              <img v-else-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'ppt'" :src="BASE_URL + 'img/ppt.png'" :alt="item.fileName"/>
              <img v-else-if="item.fileName.slice(item.fileName.indexOf('.') + 1) === 'pptx'" :src="BASE_URL + 'img/ppt.png'" :alt="item.fileName"/>
              <img v-else :src="BASE_URL + 'img/zwt.png'" :alt="item.fileName"/>
              <p>{{item.fileVideoName}}</p>
            </li>
          </ul>
        </div>
        <div class="docdetail-product">
          <h3>相关产品</h3>
          <div
            v-if="relatedProducts === null || relatedProducts.length === 0"
            style="margin: 40px 0; font-size: 20px; text-indent: 2em;"
          >
            暂无相关产品
          </div>
          <ul v-if="relatedProducts">
            <li v-for="item in relatedProducts" :key="item.id">
              <img :src="item.pollings[0].url" :alt="item.name">
              <p>{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="docdetail-hotdiscuss">
          <h3>热门评论 <span v-if="commentCounts">（共{{commentCounts}}条）</span></h3>
          <h3 v-if="commentList === null || commentList.length === 0">共0条 暂无评论</h3>
          <textarea
            style="
              padding: 10px;
              border-radius: 4px;
            "
            placeholder="请输入您的评论（不得超过1000字）..."
            v-model.trim="discussText"></textarea>
          <div @click="publishjl" class="docdetail-discuss-publish">发表</div>
          <ul v-if="commentList">
            <li v-for="item in commentList" :key="item.id" class="docdetail-discuss-detail">
              <img :src="item.userAvatarURL" :alt="item.userNickname">
              <div>
                <p>{{item.userNickname}}</p>
                <p>{{item.fileRepliyContent}}</p>
                <p>{{item.createTime}}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="doclist-pagination" v-if="commentList === null || commentList.length !== 0">
          <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
          <div class="doclist-omit">{{lastOmit}}</div>
          <ul>
            <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
          </ul>
          <div class="doclist-omit">{{nextOmit}}</div>
          <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
          <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
          <div class="doclist-jump" @click="jumpFarPage">确定</div>
        </div>
      </div>
      <!-- 右侧上传及推荐列表 -->
      <div class="doclist-lastarea-r">
        <!-- 上传按钮 -->
        <div class="doclist-upload" @click="showUpload">
          上传文档
        </div>
        <!-- 热门下载排行列表 -->
        <div class="doclist-hotdownloads">
          <h3>热门下载排行</h3>
          <ul v-if="hotDownloads">
            <li v-for="(item,index) in hotDownloads" :key="item.id" @click="jumpDocDetail(item)">
              <img :alt="item.fileTitle" v-if="index + 1 === 1" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAkCAYAAABxE+FXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjQxQzlEQkVBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjQxQzlEQkZBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNDFDOURCQ0ExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNDFDOURCREExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpwY+9gAAAHZSURBVHjaYpRNXfGfYQDA1ho3BiaGAQSjlo88y1nI0aQswcvgYSgD57/68J1h9fEHtLech4OFYW62LYOSOC9c7PLDd2RZTnKw9yaYo1hMl2Dn42RlqAszYPA0kqFfnIvxczCEWysyJDipMYjycdAvwbGzMjOc6PBlYGFmon9WY2RkwLD4zvNPGOr+0zqf//z9l6F7w2UGn7bd9Ivz20Cfrjx6j2EdMCu9+fyTgZWKUYDX8h+//jI4128fLdtHLR+1fNRy+rVkfv/9xyCXtnI02Eeo5ZzsLPRNcExMjOBmc7anJoOiGC/Dwv23GebsucXw9vMP2lnOysLEEGiuwJDlocGI3HoFOSLZWY1h2eF7/2fuusHw/P036lnOBQzaKFtlhjQ3dUYJAU6sajjYmBmSnFUZYx2UGdYef/B/2o7rDA9efSHfcgFudmCLVYUhyUmNUYCbjbjQAbZyImyUGMOArd3Npx//n7L9OsPNpx+Itxzku1RXdYZoO2VGLjITFBOw5elvJscIxAy7Lj77P3nbNYaL99/itlwRGI+Z7hoMwZYKjNRsp7npSzECMcPh6y/Bjjhx8xVC0rN55//NZx79//fvP8P//7THZ+68+R8/6dB/YP/uP0CAAQBiHNQeibKNaAAAAABJRU5ErkJggg==">
              <img :alt="item.fileTitle" v-if="index + 1 === 2" src="data:image/png;base64,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">
              <img :alt="item.fileTitle" v-if="index + 1 === 3" src="data:image/png;base64,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">
              <p><span>{{index + 1}}.</span>{{item.fileTitle}}</p>
            </li>
          </ul>
        </div>
        <!-- 热门推荐列表 -->
        <div class="doclist-hotcommend">
          <h3>热门推荐</h3>
          <ul v-if="hotCommend">
            <li v-for="item in hotCommend" :key="item.id" @click="jumpDocDetail(item)">
              <div></div>
              <p>{{item.fileTitle}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
// 引入埋点方法
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      // 收藏后红心icon base64码
      likeUrl: 'data:image/png;base64,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',
      // 未收藏蓝心icon base64码
      notLikeUrl: 'data:image/png;base64,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',
      hotDownloads: null, // 热门下载列表
      hotCommend: null, // 热门推荐列表
      currentPage: 1, // 评论当前页码
      totalPage: 8, // 评论页数总数
      lastOmit: '', // 控制页码列表前是否显示 ...
      nextOmit: '...', // 控制页码列表后是否显示 ...
      pageList: [1, 2, 3, 4, 5], // 页码列表
      jumpTargetPage: 1, // 跳到哪一页v-model
      commentCounts: null, // 评论数量
      commentList: null, // 评论列表
      fileMessage: null, // 当前文档信息存储obj
      relatedDocuments: null, // 相关文档存储obj
      relatedProducts: null, // 相关产品存储obj
      discussText: '', // 评论框v-model
      svgList: null, // 文档详情svg图片list
      value: null, // 评分展示
      rateValue: null, // 进行评分
      isRateMaskShow: false, // 控制评分蒙版显隐
      // 上传相关
      uploadFile: null,
      headerMsg: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      uploadURL: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/fileConvert',
      uploadFileTitle: '',
      uploadFileScore: 0,
      uploadFileDescribe: '',
      activeUploadFileTypeOneIndex: null,
      activeUploadFileTypeTwoIndex: null,
      activeUploadFileTypeThreeIndex: null,
      activeUploadFileTypeTwoId: null,
      activeUploadFileTypeThreeId: null,
      uploadFileTypeChooseOne: null,
      uploadFileTypeChooseTwo: null,
      uploadFileTypeChooseThree: null,
      uploadData: null,
      isUploadShow: false,
      timeout: false,
      fileList: [],
      routerQuery: {}
    }
  },
  methods: {
    // handleChange (file, fileList) {
    //   console.log('file')
    //   // if (this.$refs.upload.uploadFiles[0].size > 104857600) {
    //   //   this.$message.warning('请不要上传大于100mb的文件')
    //   //   this.$refs.upload.clearFiles()
    //   // }
    // },
    cancelUpload () {
      this.isUploadShow = false
      if (this.fileList.length) {
        for (let index = 0; index < this.fileList.length; index++) {
          this.removeFile(this.fileList[index])
        }
      }
    },
    handleUploadFileTypeOneChoose (index, item) {
      if (item.children === null) {
        this.$message.success('此分类仍在建设中，请选择其他分类')
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
      } else {
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.activeUploadFileTypeOneIndex = index
        this.uploadFileTypeChooseTwo = item.children
      }
    },
    handleUploadFileTypeTwoChoose (index, item) {
      if (item.children === null) {
        this.$message.error('此分类仍在建设中，请选择其他分类')
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = null
      } else {
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = index
        this.activeUploadFileTypeTwoId = item.id
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = item.children
      }
    },
    handleUploadFileTypeThreeChoose (index, item) {
      this.activeUploadFileTypeThreeIndex = index
      this.activeUploadFileTypeThreeId = item.id
    },
    handleExceed () {
      this.$message.error('上传文件数量不能超过一个')
    },
    handleSuccess (data) {
      // if (data.result.code !== 0) {
      //   this.$refs.upload.uploadFiles.pop()
      //   this.$message.error(data.result.msg || '上传失败')
      //   return false
      // }
      // this.$message.success('上传成功，请等待审核')
      // this.isUploadShow = false
      // console.log(data.result.aliOssId)
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/save`, {
        fileTitle: this.uploadFileTitle,
        score: this.uploadFileScore,
        discribe: this.uploadFileDescribe,
        fileTypeId: this.activeUploadFileTypeThreeId,
        ossId: this.fileList[0].ossId,
        downloaded: true
      })
        .then(({ data }) => {
          if (data.code === 0) {
            track.clickUploadFile(this.uploadFileTitle)
            this.$message.success('上传成功，请等待审核')
            this.isUploadShow = false
          } else {
          }
        })
        .catch(() => {
          this.$message.error('服务器记录文档失败，请检查与服务器的连接，稍后再试')
        })
    },
    showUpload () {
      if (this.$store.state.user.id) {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFileType`, {
          userId: this.$store.state.user.id || null
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.isUploadShow = true
              this.uploadFileTitle = ''
              this.uploadFileScore = 0
              this.uploadFileDescribe = ''
              this.activeUploadFileTypeOneIndex = null
              this.uploadFileTypeChooseTwo = null
              this.uploadFileTypeChooseThree = null
              this.activeUploadFileTypeTwoIndex = null
              this.activeUploadFileTypeTwoId = null
              this.activeUploadFileTypeThreeIndex = null
              this.activeUploadFileTypeThreeId = null
              this.$refs.upload.clearFiles()
            } else {
              this.$router.push({ name: 'login' })
            }
          })
          .catch(() => {
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    submitUpload (item) {
      if (this.uploadFileTitle === '' || this.uploadFileDescribe === '') {
        this.$message.error('必须填写文档标题以及文档描述才能上传文档')
      } else if (this.uploadFileTitle.length > 200) {
        this.$message.error('文档标题不能超过200字')
      } else if (!/^[0-5]{1}$/.test(this.uploadFileScore)) {
        this.$message.error('文档下载积分请输入0-5')
      } else if (this.uploadFileDescribe.length > 1000) {
        this.$message.error('文档描述不能超过1000字')
      } else if (this.activeUploadFileTypeThreeId === null) {
        this.$message.error('必须选择三级分类才能上传文档')
      } else if (this.fileList.length === 0) {
        this.$message.error('必须选择一个文档才能上传文档')
      } else {
        this.handleSuccess()
        // if (this.$refs.upload.uploadFiles[0].size > 104857600) {
        //   this.$message.error('请不要上传大于100mb的文件')
        //   this.$refs.upload.clearFiles()
        // } else {
        //   this.$refs.upload.submit()
        //   // // console.log(this.$refs.upload.uploadFiles[0].name)
        //   // let newName = this.$refs.upload.uploadFiles[0].name.slice(0, this.$refs.upload.uploadFiles[0].name.lastIndexOf('.'))
        //   // // console.log(newName)
        //   // let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
        //   // // console.log(regx.test(newName))
        //   // if (regx.test(newName)) {
        //   //   this.$refs.upload.submit()
        //   // } else {
        //   //   this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        //   // }
        // }
      }
    },
    handleRemove () {
      // console.log(file, fileList);
    },
    handlePreview () {
      // console.log(file);
    },
    handleRate () {
      // console.log(this.rateValue)
      if (this.rateValue === 0) {
        this.$message.warning('评分不可以为0')
      } else {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfilescore/save`, {
          technicalFileId: this.$route.query.fileId,
          fileScore: this.rateValue
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('评价成功')
              this.rateValue = 0
              this.isRateMaskShow = false
              this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/technicalFileInfoPage/${this.$route.query.fileId}`, {
                userId: this.$store.state.user.id || null
              })
                .then(({ data: item }) => {
                  this.value = item.data.fileScore
                })
            } else {
              if (data.msg === '登录后再评分.') {
                this.$router.push({ name: 'login' })
              } else {
              }
            }
          })
          .catch(() => {
          })
      }
    },
    handleRateCancel () {
      this.isRateMaskShow = false
      this.rateValue = 0
    },
    download () {
      if (this.$store.state.user.id) {
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/isObjectExist/${this.fileMessage.ossId}`)
          .then(({ data }) => {
            if (data.code === 0) {
              track.clickDocDownload(this.fileMessage.fileTitle)
              this.downloadFile()
            }
          })
          .catch(() => {
            this.$message.warning('该文件不存在')
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    downloadFile () {
      this.$confirm(
        `下载${this.fileMessage.fileTitle}需要 ${this.fileMessage.score}积分?`,
        '提示',
        {
          confirmButtonText: '确定下载',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          return this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/userFileAddMinsPoint/${this.$route.query.fileId}`)
        })
        .then(() => {
          let a = document.createElement('a')
          a.href = `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/aliOssDownLoad/${this.$route.query.fileId}/${this.$store.state.user.id}`
          a.click()
        })
        .catch(err => {
          if (err !== 'cancel') {
            this.$message.warning('积分不足')
          }
        })
    },
    changeLikeState () {
      if (getAccessToken()) {
        if (this.fileMessage.collectionDataId === null) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/userCollect`, { collectionType: 'FILE', collectionDataId: this.$route.query.fileId })
            .then(({ data }) => {
              if (data.code === 0) {
                this.fileMessage.collectionDataId = 1
                this.$message.success('收藏成功')
                track.clickDocCollection(this.fileMessage.fileTitle)
              }
            })
            .catch(() => {
              // this.$router.push({ name: 'login' })
            })
        } else {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usercollectioninfo/cancelUserCollect`, { collectionType: 'FILE', collectionDataId: this.$route.query.fileId })
            .then(({ data }) => {
              if (data.code === 0) {
                this.fileMessage.collectionDataId = null
                this.$message.success('取消收藏成功')
              }
            })
            .catch(() => {
            })
        }
      } else {
        this.$message({
          type: 'error',
          message: '用户信息不能为空,请先登录'
        })
        this.$router.push({ name: 'login' })
      }
    },
    publishDiscuss () {
      if (this.discussText === '') {
        this.$message.error('请输入评论内容再进行发表')
      } else {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfilerepliypost/save`, { fileRepliyId: this.$route.query.fileId, fileRepliyContent: this.discussText, fileRepliyAnonymous: true, fileRepliyVisible: true, status: true })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('回复成功，请等待审核')
              this.discussText = ''
            } else {
              if (data.msg === '内容过长，请输入2000字以内') {
                this.$message.warning('内容过长，请输入2000字以内')
              } else {
                this.$router.push({ name: 'login' })
              }
              // this.$message.warning(data.result.msg)
              // this.$router.push({ name: 'login' })
            }
          })
      }
    },
    publishjl () {
      if (this.timeout === false) {
        this.timeout = true
        this.publishDiscuss()
      } else {
        this.$message.warning('您发表评论过于频繁，请在30s后再进行评论')
        let that = this
        setTimeout(function () {
          that.timeout = false
        }, 30000)
      }
    },
    jumpDocDetail (item) {
      track.clickDocDetail(item.fileTitle)
      this.$router.push({
        name: 'bookDocDetail',
        query: {
          fileId: item.id
        }
      })
    },
    jumpDocDetail2 (item) {
      track.clickDocDetail(item.fileVideoName)
      this.$router.push({
        name: 'bookDocDetail',
        query: {
          fileId: item.totalId
        }
      })
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.changeCommentListPage(page)
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.changeCommentListPage(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    changeCommentListPage (page) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfilerepliypost/searchFileComments`, { page: page, limit: 8, fileRepliyId: this.$route.query.fileId })
        .then(({ data }) => {
          this.commentList = data.data.data
        })
    },
    getFileTypeList () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/variableFileLevel`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.uploadFileTypeChooseOne = data.data
          } else {
          }
        })
        .catch(() => {
        })
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.data.aliOssId,
          ossName: file.name,
          name: file.name
          // uploadId: checkpoint.uploadId
        })
        this.subLoading = false
      } else {
        // console.log(this.$refs.upLoadFile.onRemove(file, fileList), file)
        // file.onError(file)
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
        let type = file.name.split('.')[1]
        let fileAcceptList = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx']
        if (!fileAcceptList.includes(type)) {
          this.$message.error('请上传正确的文件类型')
          return false
        }
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 删除文件
    removeFile (file) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.fileList[index].ossId])
            .then(item => {
              this.fileList.splice(index, 1)
            })
            .catch(() => {
            })
        }
      }
    }
  },
  computed: {
    parentName () {
      return this.fileMessage ? this.fileMessage.parentName : '技术文档详情'
    }
  },
  watch: {
    '$route' (to, from) {
      setTimeout(() => {
        this.getFileTypeList()
        this.currentPage = 1
        this.jumpTargetPage = 1
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotDownload`)
          .then((res) => {
            if (res && res.data && res.data.code === 0) {
              this.hotDownloads = res.data.data.slice(0, 10)
            }
          })
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotRecommend`)
          .then((res) => {
            if (res && res.data && res.data.code === 0) {
              this.hotCommend = res.data.data.slice(0, 10)
            }
          })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/filevideotypeattribute/inquiryRelevantInformation`, { totalId: this.$route.query.fileId, labelType: 'FILE' })
          .then((res) => {
            if (res && res.data && res.data.data) {
              this.relatedDocuments = res.data.data.fileVideoRelevantList || null
              this.relatedProducts = res.data.data.commodityEntityList || null
            }
          })
        // this.$http.post(`${window.SITE_CONFIG['apiURL']}/attribute/filevideotypeattribute/inquiryRelevantCommodity`, {totalId: this.$route.query.fileId, labelType: 'FILE'})
        // .then(data => {
        //   this.relatedProducts = data.result.data.data
        // })
        // 埋点
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
          userId: this.$store.state.user.id || null,
          eventId: 'TECHNICAL_DOC_DETAIL',
          eventType: 'click',
          desc: '技术文档详情',
          source: 'PC',
          stayTime: '',
          busId: this.$route.query.fileId || null
        })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/technicalFileInfoPage/${this.$route.query.fileId}`, {
          userId: this.$store.state.user.id || null
        })
          .then(({ data }) => {
            this.fileMessage = data.data
            this.value = data.data.fileScore
            this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/showAliOssSvg/${data.data.ossId}`)
              .then(({ data: data2 }) => {
                this.svgList = (data2.data && data2.data.svgList) || []
              })
          })
          .catch(() => {
          })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfilerepliypost/searchFileComments`, { page: 1, limit: 8, fileRepliyId: this.$route.query.fileId })
          .then(({ data }) => {
            this.commentCounts = data.data.count
            this.commentList = data.data.data
            var page = Math.ceil(data.data.count / 8)
            this.totalPage = page
            if (page >= 5) {
              this.pageList = [1, 2, 3, 4, 5]
            } else {
              var lessPageList = []
              for (let index = 1; index <= page; index++) {
                lessPageList.push(index)
              }
              this.pageList = lessPageList
              this.nextOmit = ''
            }
          })
      }, 100)
    },
    parentName (newVal) {
      document.title = newVal
    }
  },
  mounted () {
    if (sessionStorage.getItem('docListQuery')) {
      let query = JSON.parse(sessionStorage.getItem('docListQuery'))
      delete query.docListSearch
      this.routerQuery = query
    }
    this.getFileTypeList()
    this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotDownload`)
      .then((res) => {
        if (res && res.data && res.data.code === 0) {
          this.hotDownloads = res.data.data.slice(0, 10)
        }
      })
    this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotRecommend`)
      .then((res) => {
        if (res && res.data && res.data.code === 0) {
          this.hotCommend = res.data.data.slice(0, 10)
        }
      })
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/filevideotypeattribute/inquiryRelevantInformation`, { totalId: this.$route.query.fileId, labelType: 'FILE' })
      .then((res) => {
        if (res && res.data && res.data.data) {
          this.relatedDocuments = res.data.data.fileVideoRelevantList || null
          this.relatedProducts = res.data.data.commodityEntityList || null
        }
      })
    // this.$http.post(`${window.SITE_CONFIG['apiURL']}/attribute/filevideotypeattribute/inquiryRelevantCommodity`, {totalId: this.$route.query.fileId, labelType: 'FILE'})
    // .then(data => {
    //   this.relatedProducts = data.result.data.data
    // })
    // 埋点
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/consumer/knowledgeTrainRecord/save`, {
      userId: this.$store.state.user.id || null,
      eventId: 'TECHNICAL_DOC_DETAIL',
      eventType: 'click',
      desc: '技术文档详情',
      source: 'PC',
      stayTime: '',
      busId: this.$route.query.fileId || null
    })
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/technicalFileInfoPage/${this.$route.query.fileId}`, {
      userId: this.$store.state.user.id || null
    })
      .then(({ data }) => {
        this.fileMessage = data.data
        this.value = data.data.fileScore
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/showAliOssSvg/${data.data.ossId}`)
          .then(({ data: data2 }) => {
            this.svgList = (data2.data && data2.data.svgList) || []
          })
      })
      .catch(() => {
      })
    this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfilerepliypost/searchFileComments`, { page: 1, limit: 8, fileRepliyId: this.$route.query.fileId })
      .then(({ data }) => {
        this.commentCounts = data.data.count
        this.commentList = data.data.data
        var page = Math.ceil(data.data.count / 8)
        this.totalPage = page
        if (page >= 5) {
          this.pageList = [1, 2, 3, 4, 5]
        } else {
          var lessPageList = []
          for (let index = 1; index <= page; index++) {
            lessPageList.push(index)
          }
          this.pageList = lessPageList
          this.nextOmit = ''
        }
      })
  }
}
</script>

<style scoped>
/* 上传按钮样式 */
.doclist-upload {
  width: 280px;
  height: 78px;
  background: url(data:image/png;base64,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)
    no-repeat 69px 28px;
  background-size: 28px 25px;
  background-color: #1d65a8;
  text-indent: 112px;
  line-height: 78px;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 40px;
}
/* 上传文件蒙版样式 */
.upload-cancel {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  font-size: 14px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.upload-cancel:hover {
  opacity: 0.8;
}
.doc-upload {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.uploadPickUp {
  width: 106px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.uploadPickUp .el-icon-upload2 {
  color: #595959;
  font-size: 14px;
}
.doc-upload-area h3 {
  height: 30px;
  font-size: 20px;
  margin: 10px 0;
}
.doc-upload-area input {
  width: 92%;
  margin: 0 auto;
  line-height: 24px;
  font-size: 18px;
  display: block;
  border: 1px solid #cccccc;
  padding: 4px 10px;
  border-radius: 6px;
}
.doc-upload-area input:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-typechoose ul {
  padding-left: 80px;
}
.doc-upload-kindonechoose ul {
  margin-top: -30px;
}
.doc-upload-area textarea {
  width: 92%;
  height: 80px;
  line-height: 20px;
  resize: none;
  font-size: 16px;
  margin: 0 auto 20px auto;
  display: block;
  padding: 4px 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
}
.doc-upload-area textarea:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-area .el-upload__tip {
  word-break: break-all;
}
.doc-upload-fileorvedio {
  display: flex;
  margin-bottom: 20px;
}
.doc-upload-fileorvedio div {
  padding: 2px 10px;
  text-align: center;
  margin: 0 10px;
  border: 1px solid #1d65a8;
  user-select: none;
  cursor: pointer;
}
.uploadFileTypeOneActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindonechoose {
  margin-bottom: 20px;
}
.doc-upload-kindonechoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindonechoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
.uploadFileTypeTwoActive {
  background: #1d65a8;
  color: #ffffff;
}
.uploadFileTypeThreeActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindtwochoose {
  margin-bottom: 20px;
}
.doc-upload-kindtwochoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindtwochoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
/* 订阅蒙版样式 */
.doc-subscribe {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 80px;
  top: 0;
  left: 0;
  z-index: 999;
}
.doc-subscribe-area {
  width: 530px;
  height: 89%;
  margin: auto;
  background: #ffffff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.doc-subscribe-list {
  flex: 1;
  padding: 0 32px;
  overflow-y: auto;
}
.doc-subscribe-list h3 {
  font-size: 16px;
  line-height: 22px;
  margin-top: 20px;
  margin-bottom: 30px;
  color: #333333;
}
.subscribeFirstType {
  width: 466px;
  margin-bottom: 60px;
}
.subscribeSecondType {
  width: 466px;
  display: flex;
  flex-wrap: wrap;
}
.subscribeFirstLevel {
  margin-bottom: 40px;
}
.subscribeFirstType div {
  padding: 0 8px;
  min-width: 98px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-align: center;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.2px;
  border: 1px solid #cecece;
  user-select: none;
  cursor: pointer;
}
.subscribeFirstType .activeSubscribe {
  background: #1d65a8;
  color: #ffffff;
}
.subscribeSecondType div {
  padding: 0 8px;
  min-width: 98px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  text-align: center;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.2px;
  border: 1px solid #cecece;
  margin-right: 24px;
  margin-bottom: 25px;
}
.doc-subscribe-function {
  display: flex;
  text-align: center;
}
.doc-subscribe-no {
  flex: 1;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  user-select: none;
  cursor: pointer;
}
.doc-subscribe-yes {
  flex: 1;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  background: #1d65a8;
  color: white;
  user-select: none;
  cursor: pointer;
}
/* 评分蒙版样式 */
.rate-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.rate-area {
  width: 530px;
  height: 238px;
  background: white;
  display: flex;
  flex-direction: column;
  margin: 20px auto;
}
.rate-text {
  height: 54px;
  display: flex;
  color: #333333;
}
.rate-text h3 {
  flex: 1;
  text-indent: 32px;
  line-height: 60px;
}
.rate-choose {
  padding-top: 16px;
  text-align: center;
  transform: scale(2);
}
.rate-cancel-icon {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDhGREUxQzhBQ0VDMTFFOUFEQTRFRDdENDk2MjI1OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDhGREUxQzlBQ0VDMTFFOUFEQTRFRDdENDk2MjI1OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowOEZERTFDNkFDRUMxMUU5QURBNEVEN0Q0OTYyMjU5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowOEZERTFDN0FDRUMxMUU5QURBNEVEN0Q0OTYyMjU5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmUCvhEAAADHSURBVHjanJIxDoQgEEVHTKxsqfAWnokD4AnYC+DpMFQWBgtr7Nn9JrvJskA2/oSG+S8zmfnkvSdjTAwhUIyx+uCBF0w7DEN0zpG1Vo/j+Oi6jnI6z5PmeY7rutJxHJpJKZsXTPu+XwUYShA6wQuG9X1PSqkLRiGFUwheMA1mLxnwn4OgD5iDoRz0A6YwlIMgRjf116hCCJqm6asrq23vve3cqVht5bVTNYhRaeW1aVrO+RWjEgQhhojjsiwa8LZtmu6G/CnAAHQQF6+gbr3XAAAAAElFTkSuQmCC)
    no-repeat 20px 20px;
  width: 54px;
  height: 54px;
  user-select: none;
  cursor: pointer;
}
.rate-block {
  flex: 1;
}
.rate-function {
  height: 50px;
  line-height: 50px;
  display: flex;
}
.rate-function div {
  box-sizing: border-box;
  width: 265px;
  height: 100%;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.rate-cancel {
  box-sizing: border-box;
  color: #1d65a8;
  border-top: 1px solid #1d65a8;
  border-right: 1px solid #1d65a8;
  border-bottom: 1px solid #1d65a8;
  border-left: 1px solid #1d65a8;
}
.rate-function div:nth-of-type(2) {
  background: #1d65a8;
  color: white;
}
/* 热门下载排行 */
.doclist-hotdownloads ul li {
  list-style: none;
  user-select: none;
  cursor: pointer;
}
.doclist-hotcommend ul li {
  list-style: none;
  user-select: none;
  cursor: pointer;
}
.doclist {
  width: 1230px;
  padding: 0 20px;
  margin: 0 auto;
  padding-top: 20px;
  margin-bottom: 20px;
}
.doclist-lastarea {
  display: flex;
}
.doclist-lastarea-l {
  width: 890px;
  padding: 20px 30px 0 30px;
  margin-right: 20px;
  margin-top: 20px;
  background: #fff;
}
.doclist-lastarea-r {
  margin-top: 20px;
  background: #fff;
  flex: 1;
}
.doclist-hotdownloads {
  margin: 12px 20px 62px 26px;
}
.doclist-hotdownloads h3 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}
.doclist-hotdownloads ul li {
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
}
.doclist-hotdownloads ul li img {
  position: absolute;
  width: 15.5px;
  height: 18px;
  left: 0;
  top: 8px;
}
.doclist-hotdownloads ul li p {
  width: 233px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.doclist-hotdownloads ul li p span {
  display: inline-block;
  width: 23px;
}
/* 热门推荐样式 */
.doclist-hotcommend {
  margin: 0 20px 0 26px;
}
.doclist-hotcommend h3 {
  margin-top: 0;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 18px;
}
.doclist-hotcommend ul li {
  display: flex;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
}
.doclist-hotcommend ul li div {
  width: 6px;
  height: 6px;
  margin: auto 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #1d65a8;
}
.doclist-hotcommend ul li p {
  margin: 0 0;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 左侧列表样式 */
.docdetail-message h2 {
  line-height: 46px;
  font-size: 24px;
  color: #333333;
  font-weight: 600;
  margin-bottom: 9px;
  word-break: break-all;
}
.docdetail-about {
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.docdetail-about img {
  width: 30px;
  height: 30px;
  margin-right: 20px;
}
.docdetail-showmark {
  margin-left: 52px;
  flex: 1;
  display: flex;
  margin-bottom: 10px;
}
.docdetail-showmark .el-rate {
  margin: auto 0 auto 0;
}
.docdetail-likeicon {
  display: flex;
  color: #1d65a8;
  user-select: none;
  cursor: pointer;
}
.docdetail-about .docdetail-likeicon img {
  width: 16px;
  height: 16px;
  margin: auto 7px auto 0;
}
.docdetail-function {
  margin-top: 17px;
  margin-bottom: 96px;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  display: flex;
}
.docdetail-function div {
  width: 150px;
  height: 40px;
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;
}
.docdetail-function div:nth-of-type(1) {
  background: #1d65a8;
  color: #ffffff;
  margin: 0 10px 0 262px;
}
.docdetail-function div:nth-of-type(2) {
  border: 1px solid #1d65a8;
  color: #1d65a8;
}
/* 分页样式 */
.doclist-pagination .pageactive {
  background: #1d65a8;
  color: #ffffff;
}
.doclist-pagination {
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.doclist-pagination ul {
  display: flex;
}
.doclist-pagination ul li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.doclist-omit {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage {
  font-size: 14px;
  color: #666666;
}
.doclist-nextpage {
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
}
.doclist-pagejump {
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input {
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
}
.doclist-jump {
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.doclist-lastpage {
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage {
  user-select: none;
  cursor: pointer;
}
/* 评论区域样式 */
.docdetail-hotdiscuss h3 {
  font-size: 20px;
  margin-bottom: 36px;
}
.docdetail-hotdiscuss span {
  font-size: 14px;
  color: #676767;
  line-height: 26px;
  font-weight: normal;
}
.docdetail-hotdiscuss textarea {
  width: 831px;
  height: 190px;
  line-height: 30px;
  resize: none;
  font-size: 18px;
}
.docdetail-discuss-publish {
  width: 150px;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  background: #1d65a8;
  text-align: center;
  margin-top: 16px;
  margin-left: 681px;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  margin-bottom: 20px;
}
.docdetail-discuss-detail {
  display: flex;
  margin-bottom: 55px;
}
.docdetail-discuss-detail img {
  width: 55px;
  height: 55px;
  margin-right: 16px;
}
.docdetail-discuss-detail p {
  line-height: 28px;
}
.docdetail-discuss-detail p:nth-of-type(1) {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
}
.docdetail-discuss-detail p:nth-of-type(3) {
  color: #a7a7a7;
  font-size: 12px;
}
.docdetail-discuss-detail p:nth-of-type(2) {
  font-weight: bold;
  color: #3b3b3b;
  font-size: 14px;
}
/* 相关文档样式 */
.docdetail-trivia h3 {
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
.docdetail-trivia ul {
  display: flex;
  justify-content: center;
}
.docdetail-trivia ul li {
  width: 136px;
  text-align: center;
  margin-right: 29px;
  margin-left: 29px;
  margin-top: 40px;
  margin-bottom: 85px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  cursor: pointer;
  user-select: none;
}
.docdetail-trivia ul li img {
  width: 95px;
  height: 85px;
  margin: 0 auto;
}
/* 相关产品样式 */
.docdetail-product h3 {
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
.docdetail-product ul {
  display: flex;
}
.docdetail-product ul li {
  width: 166px;
  text-align: center;
  margin-right: 58px;
  margin-top: 40px;
  margin-bottom: 85px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.docdetail-product ul li img {
  width: 140px;
  height: 130px;
  margin: 0 auto;
}
</style>
